const InfluencerListBaseElement =
  typeof CustomHTMLElement !== "undefined" ? CustomHTMLElement : HTMLElement;

if (!window.customElements.get("influencer-list")) {
  class InfluencerList extends InfluencerListBaseElement {
    connectedCallback() {
      const box = this.querySelector(".product-variants_list-scroll");

      if (box) {
        const leftBtn = this.querySelector(".prev-next-button--prev");
        const rightBtn = this.querySelector(".prev-next-button--next");
        const allArrow = this.querySelector(".product-list_arrow");
        const item = this.querySelector(".influencer_video_li");

        this.updateArrows(box, leftBtn, rightBtn, allArrow, item);

        let resizeTimer;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            this.updateArrows(box, leftBtn, rightBtn, allArrow, item);
          }, 500);
        });
      }

      const videoInit = Array.from(
        this.querySelectorAll(".influencer_video_li"),
      );

      videoInit.forEach((item) => {
        item.addEventListener("click", () => {
          this.isShowMainVideo(item);
        });
      });

      const influencerUl = this.querySelector(".influencer_ul");

      if (influencerUl) {
        this.showPlayFragmentVideo(influencerUl);
      }

      this.fixed_boxs = this.querySelector(".mian_video_boxs_fixed");

      if (this.fixed_boxs) {
        this.fixed_boxs.addEventListener("click", (e) => {
          const isInsideTikTokVideo = e.target.closest(".tiktok-video_hidden");

          if (!isInsideTikTokVideo) {
            this.isHiddenMainVideo();
          }
        });
      }
    }

    showPlayFragmentVideo(influencerUl) {
      const videoPlayList = Array.from(
        this.querySelectorAll(".influencer_video_li video"),
      );

      videoPlayList.forEach((video) => {
        video.muted = true;
        video.playsInline = true;
      });

      if (videoPlayList.length === 0) {
        return false;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];

          if (!entry) {
            return;
          }

          if (entry.isIntersecting) {
            videoPlayList[0].play().catch(() => {});
          } else {
            videoPlayList[0].pause();
          }
        },
        { threshold: 0.1 },
      );

      observer.observe(influencerUl);
    }

    isHiddenMainVideo() {
      const videoPlayList = Array.from(this.querySelectorAll(".tiktok-video"));

      videoPlayList.forEach((video) => {
        video.pause();
      });

      if (this.fixed_boxs) {
        this.fixed_boxs.style.display = "none";
      }

      document.documentElement.classList.toggle("lock-all", false);
    }

    isShowMainVideo(item) {
      if (this.fixed_boxs) {
        this.fixed_boxs.style.display = "block";
      }

      document.documentElement.classList.toggle("lock-all", true);

      const swiperBox = this.querySelector(".swiper-container");
      const slideElements = this.querySelectorAll(".swiper-slide");
      const totalSlides = slideElements.length;
      let initialIndex = parseInt(item.getAttribute("data-index"), 10) || 0;

      initialIndex = Math.min(
        Math.max(initialIndex, 0),
        Math.max(totalSlides - 1, 0),
      );

      const videoPlayList = Array.from(this.querySelectorAll(".tiktok-video"));

      if (initialIndex === 0 && videoPlayList[0]) {
        videoPlayList[0].play().catch(() => {});
      }

      if (swiperBox) {
        this.swiperScrollAnimation(swiperBox, initialIndex);
      }
    }

    swiperScrollAnimation(swiperBox, initialIndex) {
      new Swiper(`#${swiperBox.id}`, {
        direction: "vertical",
        mousewheel: true,
        keyboard: true,
        simulateTouch: true,
        resistanceRatio: 0,
        initialSlide: initialIndex,
        speed: 500,
        effect: "creative",
        creativeEffect: {
          prev: {
            shadow: true,
            translate: [0, "-100%", 0],
          },
          next: {
            translate: [0, "100%", 0],
          },
        },
        on: {
          slideChange() {
            const currentSlide = this.slides[this.activeIndex];
            const prevSlide = this.slides[this.previousIndex];
            const prevVideo = prevSlide?.querySelector("video");

            if (prevVideo) {
              prevVideo.pause();
            }

            const currentVideo = currentSlide?.querySelector("video");

            if (currentVideo) {
              currentVideo.currentTime = 0;
              currentVideo.play().catch(() => {});
            }
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }

    updateArrows(box, leftBtn, rightBtn, allArrow, item) {
      this._influencerScrollBox = box;
      this._influencerPrevNextEl = this.querySelector("prev-next-buttons");
      this._influencerLeftBtn = leftBtn;
      this._influencerRightBtn = rightBtn;

      const step =
        item && item.offsetWidth ? item.offsetWidth * 2 + 16 : box.clientWidth * 0.8;
      const needsArrows = box.scrollWidth > box.clientWidth;

      if (allArrow) {
        allArrow.style.display = needsArrows ? "flex" : "none";
      }

      if (!this._influencerScrollListenerAdded) {
        this._influencerScrollListenerAdded = true;
        box.addEventListener(
          "scroll",
          () => this._syncInfluencerScrollDisabled(),
          { passive: true },
        );
      }

      this._syncInfluencerScrollDisabled();

      if (leftBtn) {
        leftBtn.onclick = () => box.scrollBy({ left: -step, behavior: "smooth" });
      }

      if (rightBtn) {
        rightBtn.onclick = () => box.scrollBy({ left: step, behavior: "smooth" });
      }
    }

    _syncInfluencerScrollDisabled() {
      const box = this._influencerScrollBox;
      const prevNextEl = this._influencerPrevNextEl;
      const leftBtn = this._influencerLeftBtn;
      const rightBtn = this._influencerRightBtn;

      if (!box) {
        return;
      }

      const needsArrows = box.scrollWidth > box.clientWidth;

      if (!needsArrows) {
        if (prevNextEl) {
          prevNextEl.isPrevDisabled = true;
          prevNextEl.isNextDisabled = true;
        } else {
          if (leftBtn) leftBtn.disabled = true;
          if (rightBtn) rightBtn.disabled = true;
        }

        return;
      }

      const maxScroll = box.scrollWidth - box.clientWidth;
      const epsilon = 2;
      const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1;
      const scrollLeft = box.scrollLeft * directionFlip;

      if (prevNextEl) {
        prevNextEl.isPrevDisabled = scrollLeft <= epsilon;
        prevNextEl.isNextDisabled = scrollLeft >= maxScroll - epsilon;
      } else {
        if (leftBtn) leftBtn.disabled = scrollLeft <= epsilon;
        if (rightBtn) rightBtn.disabled = scrollLeft >= maxScroll - epsilon;
      }
    }
  }

  window.customElements.define("influencer-list", InfluencerList);
}
